import { graphql } from "../gql";

export const getAuditorUsersQueryDoc = graphql(`
  query getAuditorUsers($filter: AuditorUserFilter) {
    auditorUsers(filter: $filter) {
      nodes {
        ...AuditorUserFragment
      }
    }
  }
`);
